import axios from 'axios';

const TOKEN_KEY = 'dtx001token';
const AxiosInterceptor = axios.create({ baseURL: process.env.REACT_APP_BASE_URL_ALCOHOL });
let refreshPromise = null;
let redirecting = false;

const readToken = () => {
    try { return JSON.parse(localStorage.getItem(TOKEN_KEY)); } catch { return null; }
};

const expireSession = expectedToken => {
    // 이전 요청의 실패가 이후 새 로그인 세션을 지우지 않도록 한다.
    if (localStorage.getItem(TOKEN_KEY) !== expectedToken) return;
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem('dtx001SessionExpired', '1');
    if (!redirecting) {
        redirecting = true;
        window.location.replace('/sign-in/dtx001');
    }
};

AxiosInterceptor.interceptors.request.use(config => {
    const token = readToken();
    if (token?.accessToken) config.headers.Authorization = `Bearer ${token.accessToken}`;
    if ((config.url === '/staff/profile-img' || config.url === '/patient/profile-img') && config.method === 'get') {
        config.responseType = 'blob';
    }
    return config;
}, error => Promise.reject(error));

AxiosInterceptor.interceptors.response.use(response => response, async error => {
    if (error.response?.status !== 401) return error;
    const originalRequest = error.config;
    const snapshot = localStorage.getItem(TOKEN_KEY);
    const token = readToken();
    if (originalRequest?.sessionRetry && token?.accessToken
        && originalRequest.headers?.Authorization !== `Bearer ${token.accessToken}`) return error;
    if (!originalRequest || originalRequest.sessionRetry || !token?.refreshToken) {
        expireSession(snapshot);
        return error;
    }
    originalRequest.sessionRetry = true;

    // 다른 요청이 이미 토큰 갱신을 마쳤다면 다시 갱신하지 않고 한 번만 재시도한다.
    if (originalRequest.headers?.Authorization !== `Bearer ${token.accessToken}`) {
        originalRequest.headers = { ...originalRequest.headers, Authorization: `Bearer ${token.accessToken}` };
        return AxiosInterceptor(originalRequest);
    }
    if (!refreshPromise) {
        refreshPromise = axios.post(`${process.env.REACT_APP_AUTH_URL}/auth/token/refresh`, null, {
            params: { refreshToken: token.refreshToken },
            headers: { Authorization: null },
            timeout: 15000,
        }).then(response => {
            if (!(response.status >= 200 && response.status < 300) || !response.data?.accessToken) {
                throw new Error('Token refresh failed');
            }
            if (localStorage.getItem(TOKEN_KEY) !== snapshot) throw new Error('Session changed');
            const updated = { ...token, ...response.data };
            localStorage.setItem(TOKEN_KEY, JSON.stringify(updated));
            return updated.accessToken;
        }).finally(() => { refreshPromise = null; });
    }
    try {
        const accessToken = await refreshPromise;
        originalRequest.headers = { ...originalRequest.headers, Authorization: `Bearer ${accessToken}` };
        return AxiosInterceptor(originalRequest);
    } catch {
        expireSession(snapshot);
        return error;
    }
});

export default AxiosInterceptor;
